import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";

interface FrontModalProps {
  modalStatus: () => void;
  data: any;
}
const FrontModal: React.FC<FrontModalProps> = ({ data, modalStatus }) => {
  const [is_Copied, setIs_Copied] = useState(false);
  const handleCopy = () => {
    const couponCode = data?.attributes.coupon_code || "FESTIVE20";
    navigator.clipboard.writeText(couponCode).then(() => {
      // alert("Coupon code copied to clipboard!");
    });
    setIs_Copied(true);
  };

  const handleClose = () => {
    modalStatus();
    setTimeout(() => {
      document.querySelectorAll(".modal-backdrop").forEach((el) => el.remove());
    }, 500);
  };

  console.log("popupData=======>", data);
  return (
    <div className="modal festive-modal fade" id="frontModal">
      <div className="modal-dialog modal-dialog-centered modal-xl">
        <div className="modal-content">
          <div className="modal-header modal-header-login-close">
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={handleClose}
            ></button>
          </div>
          <div className="modal-body p-0">
            <div className="login-signup-area d-flex">
              <div className="login-signup-logo">
                <img
                  src="assets/images/login-signup-logo.svg"
                  alt="login-signup-logo"
                />
              </div>
              <div className="login-area p-0">
                <img
                  src="assets/images/festive-img.jpg"
                  alt="festive-img"
                  className="festive-img"
                />
                <div className="festive-hdng">
                  {data?.attributes.heading_4 || "Festive Season Special!"}
                </div>
              </div>
              <div className="signup-area">
                <h3> {data?.attributes.heading_1 || "Unlock"}</h3>
                <h3>
                  <strong>
                    {" "}
                    {data?.attributes.heading_2 || "FLAT 20% OFF"}
                  </strong>
                </h3>
                <h3> {data?.attributes.heading_3 || "on all assignments!"} </h3>
                <h4> {data?.attributes.text_1 || "Hurry, offer ends soon!"}</h4>
                <div className="cc-bx">
                  Use code:{" "}
                  <strong> {data?.attributes.coupon_code || "FESTIVE20"}</strong>
                  <button
                    onClick={handleCopy}
                    className="copy-btn"
                    style={{ position: "relative", left: "12px" }}
                  >
                    <i
                      className={`fas ${is_Copied ? "fa-copy" : "fa-copy"}`}
                      style={{ color: is_Copied ? "white" : "gray" }}
                    ></i>
                  </button>
                </div>
                <Link
                  to={data?.attributes.button_link || "/"}
                  className="custombtn btn-1 hover-filled-slide-down"
                >
                  <span>
                    {data?.attributes.button_text || "Claim Offer Now"}
                  </span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FrontModal;
